import React, {Component} from 'react';
import {FormTextAreaMinMax} from '@homeaway/react-form-components';
import {SVGIcon} from '@homeaway/react-svg';
import {CHECK__24} from '@homeaway/svg-defs/lib/defs/CHECK__24';
import {ALERT__24} from '@homeaway/svg-defs/lib/defs/ALERT__24';
import {ButtonPrimary} from '@homeaway/react-buttons';

import './TravelerModification.less';
import translate from '../../../../../../utils/translations';

export class TravelerModification extends Component {
    render() {
        const {
            shortDisplayName,
            reason,
            translations,
            travelerModificationError,
            travelerModificationSubmitted,
            onChange,
            value,
            onClose,
        } = this.props;

        const message = travelerModificationError
            ? {
                  icon: ALERT__24,
                  iconClass: 'text-danger',
                  text: translate(
                      translations,
                      'trav-dash/trav-home',
                      'messages',
                      'th.inbox.conversation.cancel.change.failed.text'
                  ),
                  title: translate(
                      translations,
                      'trav-dash/trav-home',
                      'messages',
                      'th.inbox.conversation.cancel.change.failed.title'
                  ),
              }
            : {
                  icon: CHECK__24,
                  iconClass: 'text-link',
                  text: translate(
                      translations,
                      'trav-dash/trav-home',
                      'messages',
                      'th.inbox.conversation.cancel.change.submit.text',
                      {
                          name: shortDisplayName,
                      }
                  ),
                  title: translate(
                      translations,
                      'trav-dash/trav-home',
                      'messages',
                      'th.inbox.conversation.cancel.change.submit.title'
                  ),
              };

        if (travelerModificationSubmitted || travelerModificationError) {
            return (
                // Re-using ChangeOfPlans__status style.
                <div className="ChangeOfPlans__status TravelerModification__status">
                    <SVGIcon
                        className={`ChangeOfPlans__icon ${message.iconClass}`}
                        markup={message.icon}
                    />
                    <h3>{message.title}</h3>
                    <p>{message.text}</p>
                    {message.iconClass !== 'text-danger' && (
                        <ButtonPrimary
                            className="status-confirmation"
                            label="Done"
                            onClick={onClose}
                        />
                    )}
                </div>
            );
        }

        return (
            <div className="cancel-trip-modal-form CancelTrip__step TravelerModification">
                <h2>
                    {translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'bookingChange.header'
                    )}
                </h2>
                <p className="ChangeOfPlans__note">
                    {translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'bookingChange.description'
                    )}
                </p>
                <p className="TravelerModification__reason">
                    {translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'bookingChange.reason.label'
                    )}
                </p>
                <p className="traveler-modification__reason-text">
                    <b>{reason.text}</b>
                </p>
                <FormTextAreaMinMax
                    id={'request-change-input'}
                    label={translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'th.inbox.conversation.cancel.change.form'
                    )}
                    lingua={{
                        maxCharErrorMessage: translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.maxCharErrorMessage'
                        ),
                    }}
                    maxChars={1000}
                    onChange={onChange}
                    rows={6}
                    value={value}
                />
                <p className="ChangeOfPlans__note">
                    {translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'bookingChange.note.1'
                    )}
                </p>
                <p className="ChangeOfPlans__note">
                    {translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'bookingChange.note.2'
                    )}
                </p>
            </div>
        );
    }
}

export default TravelerModification;
